<template lang="pug">
.custom-tab
  template(v-for='(item, index) in tabItems')
    .tab-item.flex-fill(
      :key='index'
      :class='(index == selectedTabIndex ? `selected`:``)'
      @click='selectedTabIndex = index'
    )
      template(v-if='tabItemsOptions[index] && tabItemsOptions[index].showNotificationDot')
        .notification-dot.mr-2
      div(v-html='item')
</template>

<script>
export default {
  props: {
    tabItems: {
      default: [
        'item 1',
        'item 2',
      ],
    },
    tabItemsOptions: {
      // default: [
      //   {
      //     showNotificationDot: false,
      //   },
      //   {
      //     showNotificationDot: true,
      //   },
      // ],
      default: () => ({}),
    },
    // selected index
    value: {
      default: undefined,
    },
  },
  watch: {
    selectedTabIndex: {
      handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true,
    },
    value(newVal) {
      this.selectedTabIndex = newVal;
    },
  },
  data: () => ({
    selectedTabIndex: undefined,
  }),
  mounted() {
    this.selectedTabIndex = this.value;
  },
};
</script>

<style lang="scss">
$tab-text-color: #3E3F42;
$tab-border-radius: 8px;

.custom-tab {
  display: flex;
  background: #F4F4F4;
  border-top-left-radius: $tab-border-radius;
  border-bottom-right-radius: $tab-border-radius;
  height: 52px;
  .tab-item {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 8px 32px;
    margin-top: 8px;

    font-size: 16px;

    border-top-left-radius: $tab-border-radius;
    border-top-right-radius: $tab-border-radius;

    transition: all 0.1s;
    color: rgba($tab-text-color, 0.5);

    cursor: pointer;

    &:hover {
      background: rgba(#000, 0.1);
    }
    &.selected {
      color: rgba($tab-text-color, 1);
      background: #fff;
    }
    &:last-child {
      border-top-right-radius: 0;
    }
  }
}
</style>
